module.exports = __webpack_public_path__ + "static/media/datasheet_team_row0_image.6366bc98.png";